import * as React from 'react';

import MoneyView from 'shared/components/MoneyView';
import { TransactionInfo } from 'components/PositionDetailsModal/components/TransactionInfo';
import Fees from '../Fees';
import { DateTime } from 'components/PositionDetailsModal/components/DateTime';
import { StockPositionDetailsBuyFragment } from './__generated__/StockPositionDetailsBuyFragment';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import NumberView from 'shared/components/NumberView';

interface Props {
  transaction: StockPositionDetailsBuyFragment;
}

type Enhanced = Props & InjectedTranslateProps;

function BuyView({ transaction, t }: Enhanced) {
  if (!transaction || !transaction.quantity) {
    return null;
  }

  const { quantity, price, netAmount, amount, createdAt } = transaction;

  return (
    <TransactionInfo
      title={t('Buying')}
      items={[
        <NumberView>{quantity}</NumberView>,
        <MoneyView cents>{price}</MoneyView>,
        <MoneyView cents>{amount}</MoneyView>,
        <Fees transaction={transaction} />,
        <MoneyView cents>{{ value: -netAmount.value, currency: netAmount.currency }}</MoneyView>,
        <DateTime>{createdAt}</DateTime>,
      ]}
    />
  );
}

export const Buy = translate(BuyView);
